
import { defineComponent, watchEffect } from 'vue';
import { CoupomService } from './coupom.service';
const coupomService = new CoupomService();

export default defineComponent({
    name: 'TableViewBatch',
    emits: ['delete-lot', 'download-csv'],
    props:{
        dataCoupom: {
            type: Array,
            required: true
        },
        loaderTable: {
            type: Boolean
        }
    },
    setup(props, {emit}){
        const onDeleteLot = (id: any) => {
            emit('delete-lot', id);
        }

        const onDownloadCsv = (id: any) => {
            emit('download-csv', id);
        }

        return {
            onDeleteLot, onDownloadCsv
        }
    },
    data(){
        return{
            coupoms:[] as any,
            coupom: {} as any,
            params:{ page: 0, size: 10, total: 0},
        }
    },

    methods:{
        deleteLotEmit(){
            this.$emit('delete-lot');
        },

        downloadCsv(){
           this.$emit('download-csv');
        }
    }
})
